import { observer } from 'mobx-react';
import { Title } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBoxArrowUpRight } from '@react-icons/all-files/bs/BsBoxArrowUpRight';
import { BsChatSquareDots } from '@react-icons/all-files/bs/BsChatSquareDots';
import { BsPhone } from '@react-icons/all-files/bs/BsPhone';
import { Route, RouteComponentProps } from 'react-router';
import { MassEmails } from './MassEmails';

export interface IAdminViewProps extends RouteComponentProps<undefined> {}

@observer
export class AdminView extends React.Component<IAdminViewProps> {
    public render() {
        return (
            <div className="container-fluid h-100" id="not-found">
                <Title>Admin</Title>

                <div className="row justify-content-center">
                    <Route path="/admin" exact component={MassEmails} />
                </div>
            </div>
        );
    }
}
